import { Api } from "@/plugins/api"


export default {
    chargerCollecte({ commit, getters }, { identifiantCollecte, forceRefresh }) {

        return new Promise(function (resolve, reject) {
            let collecte = getters.collecteById(identifiantCollecte);
            if (!collecte || forceRefresh) {
                commit('setState', { field: 'collecteEnChargement', value: true })
                Api
                    .get('collecte/' + identifiantCollecte)
                    .then((response) => {
                        const collecteRes = response.data
                        if (!collecte) {
                            commit('addCollecte', collecteRes)
                        } else {
                            commit("updateCollecte", { oldCollecte: collecte, newCollecte: collecteRes })
                        }
                        resolve(collecteRes)
                    })
                    .catch((erreur) => {
                        reject(erreur)
                    })
                    .finally(() => {
                        commit('setState', { field: 'collecteEnChargement', value: false })
                    })
            } else {
                resolve(collecte);
            }
        });
    }
}